import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { FaUserCircle, FaIdCard, FaComments, FaCheck, FaTimes } from 'react-icons/fa'
import '../../assets/css/FollowersList.css'
import { Clock12, Link, QrCode } from 'lucide-react'
import BiolinkQRCode from '../biolink-page/BiolinkQRCode'

export default function RequestList({
    incomingRequests,
    outgoingRequests,
    onAccept,
    onReject,
    onWithdraw,
    getInitials
}) {
    const [activeSubTab, setActiveSubTab] = useState('incoming')
    const [qrShow, setQRShow] = useState(false)
    const [qrCode, setQrCode] = useState(false)

    const handleQR = (data) => {
        setQrCode(data)
        setQRShow(true)
    }

    const renderRequestCard = (request, index, type) => {
        const profileImage = request?.user?.profile?.profile_photo
        
        // Handle potential 'undefined' strings and trailing spaces
        const rawTitle = request?.user?.profile?.title
        const rawName = request?.user?.name
        const validTitle = (rawTitle && rawTitle !== 'undefined' && rawTitle !== 'null') ? rawTitle : null
        const validName = (rawName && rawName !== 'undefined' && rawName !== 'null') ? rawName : null
        
        const userName = (validTitle || validName || 'User').trim()
        const initials = getInitials(userName)
        const userId = request?.user?.user_name

        return (
            <div key={index} className="follower-card">
                <div className="follower-card-header">
                    <div className="follower-profile-section">
                        {profileImage ? (
                            <img
                                src={process.env.REACT_APP_BASE_URL + profileImage}
                                alt={userName}
                                className="follower-profile-image"
                                onError={(e) => {
                                    e.target.style.display = 'none'
                                    e.target.nextSibling.style.display = 'flex'
                                }}
                            />
                        ) : null}
                        <div
                            className="follower-profile-avatar"
                            style={{ display: profileImage ? 'none' : 'flex' }}
                        >
                            {initials}
                        </div>
                        <div className="follower-profile-info">
                            <h6 className="follower-name">{userName}</h6>
                            <div className='d-flex align-items-center'>
                                <a
                                    className="btn btn_qr_code"
                                    href={process.env.REACT_APP_BASE_URL + `x/${request?.user?.user_name}`}
                                    title="Copy URL"
                                    target="_blank"
                                >
                                    <Link size={15} className='mb-1' />
                                </a>
                                <button
                                    className='ms-2 btn btn_qr_code'
                                    onClick={() => handleQR(request)}
                                    title="QR Code"
                                >
                                    <QrCode size={15} className='mb-1' />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="follower-card-body">
                    <div className="follower-info-item">
                        <FaIdCard className="follower-info-icon" />
                        <div className="follower-info-content">
                            <span className="follower-info-label">Username</span>
                            <span className="follower-info-value">{userId || 'N/A'}</span>
                        </div>
                    </div>
                </div>

                <div className="follower-card-footer">
                    {type === 'incoming' ? (
                        <>

                            <Button
                                variant="danger"
                                className="follower-action-btn"
                                onClick={() => onReject(request)}
                            >
                                <FaTimes className="me-2" />
                                Reject
                            </Button>
                            <Button
                                variant="success"
                                className="follower-action-btn"
                                onClick={() => onAccept(request)}
                            >
                                <FaCheck className="me-2" />
                                Accept
                            </Button>
                            {/* <Button
                                variant="primary"
                                className="follower-action-btn follower-chat-btn"
                                onClick={() => onChat(request)}
                            >
                                <FaComments className="me-2" />
                                Chat
                            </Button> */}
                        </>
                    ) : (
                        <>
                            <div
                                className="follower-action-btn text-warning"
                                style={{ background: 'transparent', border: 'none', cursor: 'default', pointerEvents: 'none' }}
                            >
                                <Clock12 size={16} className="me-1" />
                                Pending
                            </div>
                            <Button
                                variant="danger"
                                className="follower-action-btn"
                                 onClick={() => onWithdraw(request)}
                            >
                                <FaTimes className="me-2" />
                                Withdraw
                            </Button>
                        </>
                    )}
                </div>
            </div>
        )
    }

    return (
        <>
            {/* Sub-tab Navigation */}
            <div className="followers-tab-navigation mb-4" style={{ marginTop: '20px' }}>
                <button
                    className={`followers-tab-button ${activeSubTab === 'incoming' ? 'active' : ''}`}
                    onClick={() => setActiveSubTab('incoming')}
                >
                    Received
                </button>
                <button
                    className={`followers-tab-button ${activeSubTab === 'outgoing' ? 'active' : ''}`}
                    onClick={() => setActiveSubTab('outgoing')}
                >
                    Sent
                </button>
            </div>

            {/* Sub-tab Content */}
            <div className="followers-tab-content">
                {activeSubTab === 'incoming' && (
                    <>
                        {incomingRequests && incomingRequests.length > 0 ? (
                            <div className="followers-grid">
                                {incomingRequests.map((request, index) =>
                                    renderRequestCard(request, index, 'incoming')
                                )}
                            </div>
                        ) : (
                            <div className='empty-followers text-center'>
                                <FaUserCircle size={64} className="empty-icon mb-3" />
                                <h6>No Incoming Requests</h6>
                                <p className="text-muted">You don't have any pending follow requests.</p>
                            </div>
                        )}
                    </>
                )}

                {activeSubTab === 'outgoing' && (
                    <>
                        {outgoingRequests && outgoingRequests.length > 0 ? (
                            <div className="followers-grid">
                                {outgoingRequests.map((request, index) =>
                                    renderRequestCard(request, index, 'outgoing')
                                )}
                            </div>
                        ) : (
                            <div className='empty-followers text-center'>
                                <FaUserCircle size={64} className="empty-icon mb-3" />
                                <h6>No Outgoing Requests</h6>
                                <p className="text-muted">You haven't sent any follow requests.</p>
                            </div>
                        )}
                    </>
                )}
            </div>
            <BiolinkQRCode qrShow={qrShow} setQRShow={setQRShow} qrCode={qrCode} />
        </>
    )
}
